setTimeout(function () {
  // prettier-ignore
  jQuery('.home-offre ').css('left', '0px');
}, 800);

// prettier-ignore
jQuery('.icon-croix').on('click', function () {
  // prettier-ignore
  jQuery('.home-offre ').css('left', '-1200px');
});
